import { FC, useMemo } from "react";
import { IconButton, Modal } from "shared/components";
import { XClose } from "untitledui-js-base";
import { VerifiedIncomeChart } from "./VerifiedIncomeChart";
import { VerifiedIncomeGraphData } from "../types";
import { toMoney } from "utils/currency";
import moment from "moment";

type Props = {
  opened: boolean;
  onClose: () => void;
  verifiedIncomeGraphData: VerifiedIncomeGraphData[];
};

export const DetailsModal: FC<Props> = ({
  opened,
  onClose,
  verifiedIncomeGraphData
}) => {
  const dataAlignedToMonths = useMemo(() => {
    const uniqueMonths = Object.keys(
      verifiedIncomeGraphData.reduce<Record<string, number>>((acc, item) => {
        item.data.forEach((d) => {
          acc[d.x] = 1;
        });
        return acc;
      }, {})
    ).sort((a, b) => (moment("1 " + a).isBefore(moment("1 " + b)) ? -1 : 1));

    return verifiedIncomeGraphData.map((item) =>
      uniqueMonths.reduce(
        (acc, month) => {
          const dataPoint = item.data.find((d) => d.x === month) || {
            x: month,
            y: 0
          };
          acc.push(dataPoint);
          return acc;
        },
        [] as { x: string; y: number }[]
      )
    );
  }, [verifiedIncomeGraphData]);
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="max-w-[1300px] max-h-[90vh] shadow-xs border border-alpha-100 animate-appear overflow-y-auto pb-4"
    >
      <div className="flex items-center justify-between px-6 pt-6 mb-5">
        <h1 className="text-xl font-bold text-content-1000">
          Verified combined income
        </h1>
        <IconButton
          onClick={onClose}
          borderLess
          className="translate-x-2"
          Icon={XClose}
        />
      </div>
      <div className="h-[240px] px-6 ml-[50px] -mb-4">
        <VerifiedIncomeChart data={verifiedIncomeGraphData} />
      </div>
      {verifiedIncomeGraphData.length ? (
        <div className="overflow-x-auto">
          <div className="w-full">
            {dataAlignedToMonths.map((dataPoints, itemIndex) => (
              <div
                key={verifiedIncomeGraphData[itemIndex]?.id}
                className="flex w-full border-b border-alpha-40 items-center last-of-type:border-b-0"
              >
                <div className="w-[100px] py-4 px-4">
                  <p className="text-xs text-content-300">
                    {verifiedIncomeGraphData[itemIndex]?.id}
                  </p>
                </div>
                {dataPoints.map((data, index) => (
                  <div className="flex w-[100px] justify-center" key={index}>
                    <p className="text-sm text-content-1000 font-medium">
                      {toMoney(Number(data.y))}
                    </p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </Modal>
  );
};
